import React from 'react';
import { HeartHandshakeIcon, UsersIcon, ShieldCheckIcon } from 'lucide-react';
import { business } from '../data/business';
import { useLanguage } from '../contexts/LanguageContext';
const valueIcons = [UsersIcon, HeartHandshakeIcon, ShieldCheckIcon];
export function About() {
  const {
    t
  } = useLanguage();
  return <section id="nosotros" className="w-full bg-ink py-20 lg:py-28" data-id="element-24" data-mp="2yt84m9ku4m6l">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-25" data-mp="33ri06lah1osq">
        <div className="grid items-center gap-12 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16" data-id="element-26" data-mp="33p5i884prefo">
          <div data-id="element-27" data-mp="38oi4orroajhq">
            <p className="mb-4 text-xs uppercase tracking-[0.28em] text-gold" data-id="element-28" data-mp="38nzyp3f7kqwm">{t.about.eyebrow}</p>
            <h2 className="font-display text-3xl font-bold uppercase leading-tight text-cream sm:text-4xl lg:text-[2.9rem]" data-id="element-29" data-mp="3djfa7opquapv">
              {t.about.title}
            </h2>
            <div className="mt-6 space-y-5 text-base leading-relaxed text-cream/75 lg:text-lg" data-id="element-30" data-mp="3mjaqg7y5ovwr">
              <p data-id="element-31" data-mp="3rhc8qqnrcr76">{t.about.p1}</p>
              <p data-id="element-32" data-mp="3rehniwwx72cp">{t.about.p2}</p>
              <p className="border-l-2 border-gold pl-5 text-cream" data-id="element-33" data-mp="2lrqqovhyzg3s">{t.about.highlight}</p>
            </div>
          </div>

          <div className="flex items-center justify-center rounded-sm border border-gold/20 bg-panel p-8 lg:p-12" data-id="element-34" data-mp="2grcs0429diif">
            <img src={business.logo} alt={`Logo ${business.name}`} className="w-full max-w-md rounded-sm" data-id="element-35" data-mp="2cqsugzdrwcvr" />
          </div>
        </div>

        <div className="mt-16 grid gap-px overflow-hidden rounded-sm bg-gold/20 sm:grid-cols-3" data-id="element-36" data-mp="34h72iez3uuzi">
          {t.about.values.map((value, index) => {
          const Icon = valueIcons[index];
          return <div key={value.title} className="flex flex-col bg-panel p-7" data-id="element-37" data-mp="2vnahx4ll9qm7" data-mpi={index}>
                <Icon className="h-7 w-7 text-gold" aria-hidden="true" data-id="element-38" data-mp="2qpino3xh1seu" />
                <h3 className="mt-5 font-display text-xl font-semibold uppercase tracking-wide text-cream" data-id="element-39" data-mp="3o5xxy5lqafgf">
                  {value.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-cream/70" data-id="element-40" data-mp="3jd4rndam2z28">{value.text}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}